<div
	class="container-fluid vh-100 d-flex align-items-center justify-content-center login-bg"
>
	<div class="row w-100">
		<div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4 mx-auto">
			<div class="card shadow-lg">
				<!-- Top section with primary background -->
				<div class="card-header-custom text-center py-5">
					<img
						src="assets/metapress_logo_light.png"
						alt="MetaPress"
						class="mb-1 logo"
					/>
					<h2
						class="text-white fw-bold mb-0"
						style="font-size: 1.75rem"
					>
						MetaPress
					</h2>
				</div>

				<!-- Bottom section with white background -->
				<div class="card-body p-5">
					<!-- Service mode message -->
					<div *ngIf="isServiceMode" class="text-center">
						<div class="mb-4">
							<i
								class="bi bi-tools text-primary"
								style="font-size: 4rem"
							></i>
						</div>
						<h3 class="text-primary mb-3">
							{{ serviceMessageTitle }}
						</h3>
						<p
							class="text-muted mb-0"
							style="white-space: pre-line"
						>
							{{ serviceMessageText }}
						</p>
					</div>

					<!-- Loading spinner during automatic login attempt -->
					<div
						*ngIf="!isServiceMode && isLoggingIn && !showLoginForm"
						class="text-center"
					>
						<div class="spinner-border spinner-lg" role="status">
							<span class="visually-hidden">
								Kirjaudutaan sisään...
							</span>
						</div>
						<p class="mt-3 text-muted">
							<app-cycling-loading-messages
								class="d-inline-block"
								[loadingMessages]="[
									'Kirjaudutaan sisään automaattisesti...',
									'Odota vielä hetki...',
								]"
							></app-cycling-loading-messages>
						</p>
					</div>

					<!-- Login form -->
					<app-login-form
						*ngIf="!isServiceMode && showLoginForm"
						[buttonText]="'Kirjaudu sisään'"
						[showLogo]="false"
						[isLoggingIn]="isLoggingIn"
						[loginError]="loginError"
						(loginAttempt)="onLoginAttempt($event)"
					></app-login-form>

					<!-- Update check status indicator -->
					<div
						*ngIf="updateCheckStatus$ | async as updateStatus"
						class="update-status-container text-center d-flex flex-grow-1 bottom justify-content-center opacity-75"
					>
						<!-- Checking for updates -->
						<div
							*ngIf="updateStatus === 'checking'"
							class="text-muted"
						>
							<span
								class="spinner-border spinner-border-sm me-2"
								role="status"
							></span>
							<small class="text-muted"
								>Tarkistetaan päivityksiä...</small
							>
						</div>

						<!-- Up to date -->
						<div *ngIf="updateStatus === 'up-to-date'">
							<small class="text-muted"
								>Sovellus ajan tasalla.</small
							>
						</div>

						<!-- Update available -->
						<div *ngIf="updateStatus === 'update-available'">
							<small class="text-success fw-medium"
								>Uusi päivitys saatavilla. Päivitetään...</small
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
